import { SET_UNEXPECTED_ERROR, RESET_FINANCIAL_STATE } from 'actions/globalActions'
import { Reducer } from 'interfaces'
import { ErrorState } from 'interfaces/errors'

const errorReducer: Reducer<ErrorState | null> = (state = null, action) => {
  if (action.type === RESET_FINANCIAL_STATE) {
    return null
  }

  if (action.type === SET_UNEXPECTED_ERROR && !action.payload.silent) {
    return action.payload
  }

  return state
}

export default errorReducer
